import { createAction, props } from '@ngrx/store';
import { AirportsInfo } from '../../../dtos/response/airports-info-response/airports-info';
import { airportsInfoServiceFeatureKey } from './airports-info-service.state';

export const searchAirports = createAction(`[${airportsInfoServiceFeatureKey}] Search Airports`, props<{ id: string; query: string }>());

export const searchAirportsSuccess = createAction(
  `[${airportsInfoServiceFeatureKey}] Search Airports Success`,
  props<{ id: string; airports: AirportsInfo[]; loading: boolean }>()
);

export const searchAirportsFailure = createAction(
  `[${airportsInfoServiceFeatureKey}] Search Airports Failure`,
  props<{ id: string; error: string }>()
);
